import { render, staticRenderFns } from "./MetricsRV.vue?vue&type=template&id=036a99fa&scoped=true&"
import script from "./MetricsRV.vue?vue&type=script&lang=js&"
export * from "./MetricsRV.vue?vue&type=script&lang=js&"
import style0 from "./MetricsRV.vue?vue&type=style&index=0&id=036a99fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a99fa",
  null
  
)

export default component.exports